import { PROVIDER_ESCAPIO } from "./provider-codes";

/**
 * @param {boolean} isLoading
 * @param {{providers: object, offers: object[]}} loadedData
 */
function buildState(isLoading, isMinPrice, loadedData = {}) {
	return Object.freeze({
		isLoading,
		providers: loadedData?.providers,
		offers: loadedData?.offers,
		hasOffers: !!loadedData?.offers,
		hasLoadedWithoutOffers: !isLoading && !loadedData?.offers,
		bestPrice: loadedData?.offers?.[0]?.total_rate,
		isMinPrice,
	});
}

export function buildLoadedState(providers, offers) {
	return buildState(false, false, { providers, offers });
}

export function buildEscapioMinPriceState(rate, travelData) {
	return buildState(false, true, {
		providers: { [PROVIDER_ESCAPIO]: { name: "escapio" } },
		offers: [
			{
				total_rate:
					rate.min_price *
					(travelData.hasDates ? travelData.nights : 1) *
					travelData.rooms.length,
				provider: PROVIDER_ESCAPIO,
			},
		],
	});
}

export const LOADING_STATE = buildState(true, false);
export const NO_PRICES_STATE = buildState(false, false);
